var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMonster = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "monster-com-logo-2019",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.55,
    height: 42,
    viewBox: "0 0 40.55 42",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6e46ae;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4383",
    "data-name": "Path 4383",
    className: "cls-1",
    d: "M9.022,42V20.857L20.275,31.7,31.529,20.857V42H40.55V0L20.277,19.524,0,0V42Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMonster);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/monster.2d66662986d1be8a3913184fd4638c3b.svg";